import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
//utils

import { EndPoint } from '../../util/EndPoint';
//services

import { BaseService } from '../../util/BaseService';
import { RESTClientService } from '../../util/RESTClientService';
import { MensagemUtil } from '../../util/notificacao/mensagemUtil';
export class ConsultaColegioService extends BaseService {
/**
 * @param {?} _restCliente
 * @param {?} mensagemUtil
 */
constructor(private _restCliente: RESTClientService,
private mensagemUtil: MensagemUtil) {
    super(mensagemUtil);
  }
/**
 * @param {?} codigoInstituicao
 * @param {?} rgmAluno
 * @param {?} codigoEmpresa
 * @return {?}
 */
public getCombo(codigoInstituicao: number, rgmAluno: number, codigoEmpresa: number): Observable<any[]> {
    return this._restCliente.get(EndPoint.buscaComboAnoColegio(codigoInstituicao, rgmAluno, codigoEmpresa))
      .catch(error => this.handleError(error));
  }
/**
 * @param {?} codigoAluno
 * @param {?} codigoEmpresa
 * @param {?} codigoInstituicao
 * @param {?} codigoTurma
 * @return {?}
 */
public getDisciplinas(codigoAluno: number, codigoEmpresa: number, codigoInstituicao: number, codigoTurma: number): Observable<any[]> {
    return this._restCliente.get(EndPoint.buscaDisciplinasColegio(codigoAluno, codigoEmpresa, codigoInstituicao, codigoTurma))
      .catch(error => this.handleError(error));
  }
/**
 * @param {?} codigoDisciplina
 * @param {?} codigoInstituicao
 * @param {?} codigoTurma
 * @param {?} rgmAluno
 * @param {?} seqNota
 * @return {?}
 */
public getParciais(codigoDisciplina: number,
    codigoInstituicao: number,
    codigoTurma: number,
    rgmAluno: number,
    seqNota: number, ): Observable<any[]> {
    return this._restCliente.get(EndPoint.buscaParcialColegio(
      codigoDisciplina,
      codigoInstituicao,
      codigoTurma,
      rgmAluno,
      seqNota))
      .catch(error => this.handleError(error));
  }
/**
 * @param {?} codigoInstituicao
 * @param {?} codigoCurso
 * @return {?}
 */
public getBloqueioNota(codigoInstituicao: number, codigoCurso: number): Observable<any> {
    return this._restCliente.get(EndPoint.buscaBloqueioNotaColegio(codigoInstituicao, codigoCurso))
      .catch(error => this.handleError(error));
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: RESTClientService, },
{type: MensagemUtil, },
];
}

function ConsultaColegioService_tsickle_Closure_declarations() {
/** @type {?} */
ConsultaColegioService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConsultaColegioService.ctorParameters;
/** @type {?} */
ConsultaColegioService.prototype._restCliente;
/** @type {?} */
ConsultaColegioService.prototype.mensagemUtil;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
